export const staticRouter = [
    {
        path:'/',
        component:() => import('../views/Index.vue'),
        meta: { 
            title: 'Lucky Sushi | Sushi Takeaway & Levering i Køge, Greve, Slagelse',
            description: 'Lucky Sushi tilbyder frisk sushi takeaway og levering i Køge, Greve og Slagelse. Bestil online og nyd autentisk japansk mad til dine gæster.',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, japansk mad, sushi restaurant, frisk sushi, sushi menu, sushi ruller',
            h1Title: 'Lucky Sushi - Sushi Takeaway & Levering i Køge, Greve og Slagelse',
            canonical: 'https://luckysushi.dk/'
        }
    },
    {
        path:'/page/index',
        component:() => import('../views/pages/Index.vue'),
        meta: { 
            title: 'Lucky Sushi | Sushi Takeaway & Levering i Køge, Greve, Slagelse',
            description: 'Velkommen til Lucky Sushi - den bedste sushi restaurant i Køge, Greve og Slagelse. Vi tilbyder frisk sushi takeaway og levering med bred udvalg af sushi ruller, nigiri og japanske specialiteter.',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, japansk mad, sushi restaurant, frisk sushi, sushi menu, sushi ruller, nigiri, sashimi',
            h1Title: 'Lucky Sushi - Din Sushi Restaurant i Køge, Greve og Slagelse',
            canonical: 'https://luckysushi.dk/page/index'
        }
    },
    {
        path:'/coupon/:id',
        component:() => import('../views/coupon/Index.vue'),
        meta: { 
            title: 'Rabatkoder & Tilbud | Lucky Sushi',
            description: 'Spar på din sushi bestilling med vores eksklusive rabatkoder og tilbud. Få Rabat på takeaway og levering hos Lucky Sushi i Køge, Greve og Slagelse.',
            keywords: 'rabatkoder, rabat, tilbud, sushi tilbud, lucky sushi rabat, sushi rabat, takeaway tilbud, levering tilbud',
            h1Title: 'Rabatkoder & Tilbud - Spar på Din Sushi Ordre',
            canonical: 'https://luckysushi.dk/coupon/'
        }
    },
    {
        path:'/takeaway',
        component:() => import('../views/pages/Takeaway.vue'),
        meta: { 
            title: 'Sushi Takeaway Menu | Lucky Sushi',
            description: 'Gennemse vores udvalg af sushi takeaway. Vælg mellem sushi ruller, nigiri, sashimi og japanske specialiteter. Bestil online og hent dine sushi med takeaway.',
            keywords: 'takeaway menu, sushi menu, sushi takeaway, frisk sushi, sushi ruller, nigiri, sashimi, japansk mad, online bestilling',
            h1Title: 'Sushi Takeaway Menu - Bestil Online',
            canonical: 'https://luckysushi.dk/takeaway'
        }
    },
    {
        path:'/takeaway/paymentSuccess/:id',
        component:() => import('../views/results/PaymentSuccess.vue'),
        meta: { 
            title: 'Betaling Lykkedes | Tak for Din Ordre | Lucky Sushi',
            description: 'Din betaling er blevet succesfuldt behandlet. Tak for din bestilling hos Lucky Sushi. Vi glæder os til at levere din friske sushi.',
            keywords: 'betaling lykkedes, ordre bekræftelse, sushi ordre, tak for din ordre, sushi levering',
            h1Title: 'Betaling Lykkedes - Tak for Din Ordre',
            canonical: 'https://luckysushi.dk/takeaway/paymentSuccess/'
        }
    },
    {
        path:'/takeaway/paymentFailed/:id',
        component:() => import('../views/results/PaymentFailed.vue'),
        meta: { 
            title: 'Betaling Mislykkedes | Prøv Igen | Lucky Sushi',
            description: 'Din betaling var ikke succesfuld. Prøv venligst igen eller kontakt os for hjælp med din sushi ordre.',
            keywords: 'betaling mislykkedes, betaling fejl, sushi ordre, prøv igen, kontakt os',
            h1Title: 'Betaling Mislykkedes - Prøv Venligst Igen',
            canonical: 'https://luckysushi.dk/takeaway/paymentFailed/'
        }
    },
    {
        path:'/takeaway/cartList/:id',
        component:() => import('../views/pages/CartListView.vue'),
        meta: { 
            title: 'Leveringstid Vælg | Lucky Sushi',
            description: 'Vælg din foretrukne leveringstid for din sushi ordre. Vi tilbyder fleksible leveringstider til dine behov.',
            keywords: 'leveringstid, vælg tid, sushi levering, levering, sushi ordre, bestilling',
            h1Title: 'Vælg Leveringstid - Din Sushi Ordre',
            canonical: 'https://luckysushi.dk/takeaway/cartList/'
        }
    },
    {
        path:'/takeaway/buyerInfo/:id',
        component:() => import('../views/pages/BuyerInfoView.vue'),
        meta: { 
            title: 'Leveringsoplysninger | Lucky Sushi',
            description: 'Indtast dine leveringsoplysninger og afslut din sushi ordre. Hurtig og sikker checkout hos Lucky Sushi.',
            keywords: 'leveringsoplysninger, ordredetaljer, sushi levering, checkout, adresse, kontaktoplysninger',
            h1Title: 'Indtast Leveringsoplysninger',
            canonical: 'https://luckysushi.dk/takeaway/buyerInfo/'
        }
    },
    {
        path:'/contact/:customId',
        component:() => import('../views/pages/BookingTable.vue'),
        meta: { 
            title: 'Kontakt & Bordbooking | Lucky Sushi',
            description: 'Kontakt Lucky Sushi og book et bord til dit næste besøg. Vi tilbyder bordreservationer til både små og store grupper.',
            keywords: 'kontakt, booking, bordreservation, sushi restaurant, restaurant booking, møde, familie, venner',
            h1Title: 'Kontakt & Bordbooking - Lucky Sushi',
            canonical: 'https://luckysushi.dk/contact/'
        }
    },
    {
        path:'/info/:customId',
        component:() => import('../views/pages/CustomView.vue'),
        meta: { 
            title: 'Om Lucky Sushi | Information',
            description: 'Lær mere om Lucky Sushi - vores historie, vores filosofi og hvorfor vi er den bedste sushi restaurant i Køge, Greve og Slagelse.',
            keywords: 'om os, information, lucky sushi, sushi restaurant, historie, filosofi, kvalitet, frisk sushi',
            h1Title: 'Om Lucky Sushi - Vores Historie & Filosofi',
            canonical: 'https://luckysushi.dk/info/'
        }
    },
    {
        path:'/allyoucaneat/:customId',
        component:() => import('../views/pages/AllYouCanEat.vue'),
        meta: { 
            title: 'All You Can Eat Sushi | Lucky Sushi',
            description: 'Nyd vores All You Can Eat sushi menu hos Lucky Sushi. Ubegrænset sushi til en fast pris - perfekt til sushi elskere!',
            keywords: 'all you can eat, ubegrænset sushi, sushi buffet, fast pris, sushi all you can eat, sushi fest, sushi mad',
            h1Title: 'All You Can Eat - Ubegrænset Sushi',
            canonical: 'https://luckysushi.dk/allyoucaneat/'
        }
    },
    {
        path:'/register',
        component:() => import('../views/pages/Register.vue'),
        meta: { 
            title: 'Opret Konto | Lucky Sushi',
            description: 'Opret en konto hos Lucky Sushi for at nyde hurtigere checkout, ordrehistorie og eksklusive tilbud.',
            keywords: 'registrering, opret konto, sushi konto, hurtig checkout, ordrehistorie, medlemskab',
            h1Title: 'Opret Konto - Bliv Medlem',
            canonical: 'https://luckysushi.dk/register'
        }
    },
    {
        path:'/login',
        component:() => import('../views/pages/Login.vue'),
        meta: { 
            title: 'Login | Lucky Sushi Konto',
            description: 'Log ind på din Lucky Sushi konto for at få adgang til din ordrehistorie, præferencer og eksklusive rabatter.',
            keywords: 'login, konto adgang, ordrehistorie, præferencer, rabat, medlem',
            h1Title: 'Login - Din Lucky Sushi Konto',
            canonical: 'https://luckysushi.dk/login'
        }
    },
    {
        path:'/userCenter',
        component:() => import('../views/pages/UserCenter.vue'),
        meta: { 
            title: 'Brugercenter | Lucky Sushi',
            description: 'Administrer din konto, se ordrehistorie og opdater dine præferencer hos Lucky Sushi.',
            keywords: 'brugercenter, konto administration, ordrehistorie, præferencer, profil, indstillinger',
            h1Title: 'Brugercenter - Din Konto',
            canonical: 'https://luckysushi.dk/userCenter'
        }
    },
    {
        path:'/mobile/index',
        component:() => import('../views/mobile/Index.vue'),
        meta: { 
            title: 'Lucky Sushi Mobile | Sushi Takeaway & Levering',
            description: 'Bestil sushi på din mobil! Lucky Sushi tilbyder frisk sushi takeaway og levering i Køge, Greve og Slagelse via vores mobile platform.',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, mobil, mobile, sushi app, bestil sushi',
            h1Title: 'Lucky Sushi Mobile - Bestil Sushi På Gangen',
            canonical: 'https://luckysushi.dk/mobile/index'
        }
    },
    {
        path:'/mobile/login',
        component:() => import('../views/mobile/Login.vue'),
        meta: { 
            title: 'Mobile Login | Lucky Sushi',
            description: 'Log ind på din Lucky Sushi konto via vores mobile platform. Få hurtig adgang til dine ordrer og præferencer.',
            keywords: 'login, mobil login, mobile login, konto adgang, ordrehistorie, mobil app',
            h1Title: 'Mobile Login - Din Konto',
            canonical: 'https://luckysushi.dk/mobile/login'
        }
    },
    {
        path:'/mobile/userCenter',
        component:() => import('../views/mobile/UserCenter.vue'),
        meta: { 
            title: 'Mobile Brugercenter | Lucky Sushi',
            description: 'Administrer din konto og se ordrehistorie på din mobil. Hurtig og nem navigation i vores mobile brugercenter.',
            keywords: 'brugercenter, mobil brugercenter, konto administration, ordrehistorie, mobil app',
            h1Title: 'Mobile Brugercenter - Din Konto',
            canonical: 'https://luckysushi.dk/mobile/userCenter'
        }
    },
    {
        path:'/mobile/userInfo',
        component:() => import('../views/mobile/UserInfo.vue'),
        meta: { 
            title: 'Mobile Brugeroplysninger | Lucky Sushi',
            description: 'Opdater dine personlige oplysninger og præferencer på din mobil. Keep your profile up to date.',
            keywords: 'brugeroplysninger, personlige detaljer, profil, præferencer, mobil, mobile',
            h1Title: 'Brugeroplysninger - Rediger Din Profil',
            canonical: 'https://luckysushi.dk/mobile/userInfo'
        }
    },
    {
        path:'/mobile/forget',
        component:() => import('../views/mobile/Forget.vue'),
        meta: { 
            title: 'Glemt Kodeord | Nulstil | Lucky Sushi',
            description: 'Glemt dit kodeord? Nulstil det hurtigt og sikker via vores mobile platform.',
            keywords: 'glemt kodeord, nulstil kodeord, password reset, konto genoprettelse, mobil',
            h1Title: 'Glemt Kodeord - Nulstil Her',
            canonical: 'https://luckysushi.dk/mobile/forget'
        }
    },
    {
        path:'/mobile/myOrder',
        component:() => import('../views/mobile/MyOder.vue'),
        meta: { 
            title: 'Mine Ordre | Lucky Sushi Mobile',
            description: 'Se din ordrehistorie og spore dine aktuelle ordrer på din mobil. Alt i ét sted.',
            keywords: 'mine ordre, ordrehistorie, spor ordre, ordre status, mobil, mobile',
            h1Title: 'Mine Ordre - Se Din Historie',
            canonical: 'https://luckysushi.dk/mobile/myOrder'
        }
    },
    {
        path:'/mobile/takeaway',
        component:() => import('../views/mobile/Takeaway.vue'),
        meta: { 
            title: 'Mobile Takeaway | Sushi Menu | Lucky Sushi',
            description: 'Bestil sushi takeaway på din mobil. Gennemse vores menu og bestil frisk sushi til takeaway eller levering.',
            keywords: 'takeaway, sushi menu, mobil takeaway, mobile takeaway, frisk sushi, sushi ruller',
            h1Title: 'Mobile Takeaway - Bestil Sushi',
            canonical: 'https://luckysushi.dk/mobile/takeaway'
        }
    },
    {
        name:'mobileFoodList',
        path:'/mobile/takeaway/foodlist',
        component:() => import('../views/mobile/FoodListView.vue'),
        meta: { 
            title: 'Mobile Madliste | Sushi Menu | Lucky Sushi',
            description: 'Gennemse vores madmenu på din mobil. Vælg dine favorit sushi varer og tilføj dem til din kurv.',
            keywords: 'madliste, sushi menu, mobil madliste, food list, sushi varer, tilføj til kurv',
            h1Title: 'Madliste - Vælg Dine Varer',
            canonical: 'https://luckysushi.dk/mobile/takeaway/foodlist'
        }
    },
    {
        path:'/mobile/takeaway/cartlist',
        component:() => import('../views/mobile/CartListView.vue'),
        meta: { 
            title: 'Mobile Indkøbskurv | Lucky Sushi',
            description: 'Gennemse din indkøbskurv, foretag ændringer og gennemfør checkout på din mobil.',
            keywords: 'indkøbskurv, kurv, ordre gennemse, checkout, mobil, mobile',
            h1Title: 'Indkøbskurv - Gennemse Din Ordre',
            canonical: 'https://luckysushi.dk/mobile/takeaway/cartlist'
        }
    },
    {
        path:'/mobile/takeaway/time',
        component:() => import('../views/mobile/TimeView.vue'),
        meta: { 
            title: 'Mobile Leveringstid | Lucky Sushi',
            description: 'Vælg din foretrukne leveringstid på din mobil. Fleksible tider til dine behov.',
            keywords: 'leveringstid, vælg tid, sushi levering, mobil, mobile, levering',
            h1Title: 'Vælg Leveringstid',
            canonical: 'https://luckysushi.dk/mobile/takeaway/time'
        }
    },
    {
        path:'/mobile/takeaway/buyerInfo',
        component:() => import('../views/mobile/BuyerInfoView.vue'),
        meta: { 
            title: 'Mobile Leveringsoplysninger | Lucky Sushi',
            description: 'Indtast dine leveringsoplysninger på din mobil og afslut din ordre hurtigt.',
            keywords: 'leveringsoplysninger, ordredetaljer, checkout, mobil, mobile, adresse',
            h1Title: 'Indtast Leveringsoplysninger',
            canonical: 'https://luckysushi.dk/mobile/takeaway/buyerInfo'
        }
    },
    {
        path:'/mobile/takeaway/success',
        component:() => import('../views/mobile/OrderSuccessView.vue'),
        meta: { 
            title: 'Mobile Ordre Lykkedes | Lucky Sushi',
            description: 'Din ordre er blevet succesfuldt placeret. Tak for at vælge Lucky Sushi!',
            keywords: 'ordre lykkedes, ordre bekræftelse, sushi ordre, tak, mobil, mobile',
            h1Title: 'Ordre Lykkedes - Tak!',
            canonical: 'https://luckysushi.dk/mobile/takeaway/success'
        }
    },
    {
        path:'/mobile/takeaway/detail',
        component:() => import('../views/mobile/OrderDetailsView.vue'),
        meta: { 
            title: 'Mobile Ordredetaljer | Lucky Sushi',
            description: 'Se detaljerne af din ordre på din mobil. Kontroller dine varer og leveringsinformation.',
            keywords: 'ordredetaljer, ordre information, sushi ordre, mobil, mobile, detaljer',
            h1Title: 'Ordredetaljer - Din Ordre',
            canonical: 'https://luckysushi.dk/mobile/takeaway/detail'
        }
    },
    {
        path:'/mobile/contact/:customId',
        component:() => import('../views/mobile/BookingTable.vue'),
        meta: { 
            title: 'Mobile Kontakt & Booking | Lucky Sushi',
            description: 'Kontakt Lucky Sushi og book et bord via vores mobile platform. Enkelt og hurtigt.',
            keywords: 'kontakt, booking, bordreservation, mobil, mobile, sushi restaurant',
            h1Title: 'Kontakt & Booking',
            canonical: 'https://luckysushi.dk/mobile/contact/'
        }
    },
    {
        path:'/mobile/allyoucaneat/:customId',
        component:() => import('../views/mobile/AllYouCanEat.vue'),
        meta: { 
            title: 'Mobile All You Can Eat | Lucky Sushi',
            description: 'Nyd vores All You Can Eat sushi menu på din mobil. Ubegrænset sushi til en fast pris.',
            keywords: 'all you can eat, ubegrænset sushi, sushi buffet, mobil, mobile, sushi fest',
            h1Title: 'All You Can Eat - Ubegrænset Sushi',
            canonical: 'https://luckysushi.dk/mobile/allyoucaneat/'
        }
    },
    {
        path:'/mobile/takeaway/:foodTypeId',
        component:() => import('../views/mobile/Takeaway.vue'),
        meta: { 
            title: 'Mobile Takeaway Menu | Lucky Sushi',
            description: 'Gennemse vores takeaway menu efter kategori på din mobil. Find dine favorit sushi varer hurtigt.',
            keywords: 'takeaway menu, sushi menu, madkategori, mobil, mobile, sushi ruller',
            h1Title: 'Takeaway Menu - Efter Kategori',
            canonical: 'https://luckysushi.dk/mobile/takeaway/'
        }
    },
    {
        path:'/mobile/takeaway/foodlist/:foodTypeId/:foodTypeName/:showType',
        component:() => import('../views/mobile/FoodListView.vue'),
        meta: { 
            title: 'Mobile Madliste | Kategori | Lucky Sushi',
            description: 'Gennemse vores madmenu efter kategori og vælg dine favorit sushi varer.',
            keywords: 'madliste, sushi menu, madkategori, vælg varer, mobil, mobile',
            h1Title: 'Madliste - Vælg Dine Varer',
            canonical: 'https://luckysushi.dk/mobile/takeaway/foodlist/'
        }
    },
    {
        path:'/mobile/takeaway/time/:deliveryTip',
        component:() => import('../views/mobile/TimeView.vue'),
        meta: { 
            title: 'Mobile Leveringstid | Lucky Sushi',
            description: 'Vælg din foretrukne leveringstid og se tips til optimal levering.',
            keywords: 'leveringstid, vælg tid, sushi levering, leveringsbetingelser, mobil, mobile',
            h1Title: 'Vælg Leveringstid',
            canonical: 'https://luckysushi.dk/mobile/takeaway/time/'
        }
    },
    {
        path:'/mobile/takeaway/buyerInfo/:deliveryTip',
        component:() => import('../views/mobile/BuyerInfoView.vue'),
        meta: { 
            title: 'Mobile Leveringsoplysninger | Lucky Sushi',
            description: 'Indtast dine leveringsoplysninger og få tips til en glidende levering.',
            keywords: 'leveringsoplysninger, ordredetaljer, leveringsbetingelser, mobil, mobile',
            h1Title: 'Indtast Leveringsoplysninger',
            canonical: 'https://luckysushi.dk/mobile/takeaway/buyerInfo/'
        }
    },
    {
        path:'/mobile/info/:customId',
        component:() => import('../views/mobile/CustomView.vue'),
        meta: { 
            title: 'Mobile Information | Lucky Sushi',
            description: 'Lær mere om Lucky Sushi på din mobil. Vores historie, filosofi og tjenester.',
            keywords: 'information, om os, lucky sushi, historie, filosofi, mobil, mobile',
            h1Title: 'Om Lucky Sushi',
            canonical: 'https://luckysushi.dk/mobile/info/'
        }
    },
    {
        path:'/b/takeaway/:id',
        component:() => import('../views/takeaway02/IndexView.vue'),
        meta: { 
            title: 'Sushi Takeaway | Lucky Sushi',
            description: 'Bestil frisk sushi online fra Lucky Sushi. Vi tilbyder takeaway og leveringstjenester i hele regionen.',
            keywords: 'takeaway, online bestilling, frisk sushi, leveringstjenester, sushi restaurant',
            h1Title: 'Takeaway - Bestil Sushi Online',
            canonical: 'https://luckysushi.dk/b/takeaway/'
        }
    },
    {
        path:'/b/checkout/:id',
        component:() => import('../views/takeaway02/Checkout.vue'),
        meta: { 
            title: 'Checkout | Lucky Sushi',
            description: 'Afslut din ordre og foretag betaling. Hurtig, sikker og nem checkout hos Lucky Sushi.',
            keywords: 'checkout, betaling, ordre afslutning, sushi ordre, sikker betaling',
            h1Title: 'Checkout - Afslut Din Ordre',
            canonical: 'https://luckysushi.dk/b/checkout/',
            keepAlive: false 
        }
    },
    {
        path:'/b/order/:id',
        component:() => import('../views/takeaway02/OrderDetial.vue'),
        meta: { 
            title: 'Min Ordre | Lucky Sushi',
            description: 'Se detaljerne af din ordre. Kontroller dine varer, status og leveringsinformation.',
            keywords: 'min ordre, ordredetaljer, ordre information, sushi ordre, ordre status',
            h1Title: 'Min Ordre - Se Detaljer',
            canonical: 'https://luckysushi.dk/b/order/'
        }
    },
    {
        path:'/b/show/:activeIndex/:id',
        component:() => import('../views/takeaway02/Custom.vue'),
        meta: { 
            title: 'Information | Lucky Sushi',
            description: 'Lær mere om Lucky Sushi, vores menu og tjenester. Alt hvad du skal vide.',
            keywords: 'info, om os, sushi restaurant, menu, tjenester, lucky sushi',
            h1Title: 'Om Lucky Sushi',
            canonical: 'https://luckysushi.dk/b/show/'
        }
    },
    {
        path:'/b/cartList/:id',
        component:() => import('../views/takeaway02/CartList.vue'),
        meta: { 
            title: 'Kurvliste | Lucky Sushi',
            description: 'Gennemse din ordre og foretag ændringer før checkout. Tilføj eller fjern varer efter behov.',
            keywords: 'kurvliste, ordre gennemse, checkout, sushi ordre, indkøbskurv',
            h1Title: 'Kurvliste - Gennemse Din Ordre',
            canonical: 'https://luckysushi.dk/b/cartList/'
        }
    },
    {
        path:'/booking/:id',
        component:() => import('../views/booking/Index.vue'),
        meta: { 
            title: 'Bordbooking | Lucky Sushi',
            description: 'Lav en bordreservation hos Lucky Sushi til dit næste besøg. Book online og undgå ventetid.',
            keywords: 'booking, bordreservation, sushi restaurant, reservation, online booking',
            h1Title: 'Bordbooking - Book Dit Bord',
            canonical: 'https://luckysushi.dk/booking/'
        }
    },
    {
        path:'/e-invoice/:type/:id',
        component:() => import('../views/bill/Index.vue'),
        meta: { 
            title: 'E-faktura | Lucky Sushi',
            description: 'Se og download din e-faktura for din Lucky Sushi ordre. Digital og miljøvenlig.',
            keywords: 'e-faktura, faktura, download faktura, ordre faktura, digital faktura',
            h1Title: 'E-faktura - Se & Download',
            canonical: 'https://luckysushi.dk/e-invoice/'
        }
    },
    {
        path:'/pre-invoice/:type/:id',
        component:() => import('../views/bill/Preview.vue'),
        meta: { 
            title: 'E-faktura Forhåndsvisning | Lucky Sushi',
            description: 'Forhåndsvis din e-faktura før download. Kontroller dine oplysninger.',
            keywords: 'e-faktura forhåndsvisning, faktura forhåndsvisning, ordre faktura, preview',
            h1Title: 'E-faktura Forhåndsvisning',
            canonical: 'https://luckysushi.dk/pre-invoice/'
        }
    },
    {
        path:'/booking/edit/:id',
        component:() => import('../views/booking/EditBookingTable.vue'),
        meta: { 
            title: 'Rediger Booking | Lucky Sushi',
            description: 'Rediger din bordreservation hos Lucky Sushi. Ændre dato, tid eller antallet af gæster.',
            keywords: 'rediger booking, modificer reservation, bordreservation, ændre booking',
            h1Title: 'Rediger Booking',
            canonical: 'https://luckysushi.dk/booking/edit/'
        }
    },
    {
        path: '/blog',
        name: 'blog',
        component: () => import('@/views/blog/BlogList.vue'),
        meta: { 
            title: 'Blog | Lucky Sushi - Sushi & Japansk Mad',
            description: 'Læs vores seneste blogindlæg om sushi, japansk mad, madlavningstips og vores filosofi bag Lucky Sushi.',
            keywords: 'blog, sushi, japansk mad, madlavningstips, lucky sushi, køge, greve, slagelse',
            h1Title: 'Lucky Sushi Blog - Om Sushi & Japansk Mad',
            canonical: 'https://luckysushi.dk/blog'
        }
    },
    {
        path: '/blog/detail/:id',
        name: 'blog-detail',
        component: () => import('@/views/blog/BlogDetail.vue'),
        meta: { 
            title: 'Blog Indlæg | Lucky Sushi',
            description: 'Læs detaljerede blogindlæg om sushi, japansk madkultur og vores passion for kvalitet.',
            keywords: 'blog indlæg, sushi, japansk mad, madkultur, kvalitet, lucky sushi',
            h1Title: 'Blog Indlæg - Læs Mere',
            canonical: 'https://luckysushi.dk/blog/detail/'
        }
    }
]
